export class FacebookPixelService {
  private readonly window: Window
  constructor(window: Window) {
    this.window = window
  }

  async sendEvent(actionType: string, payload?: object | undefined): Promise<unknown> {
    return new Promise((resolve, reject) => {
      if (typeof this.window.fbq !== 'undefined') {
        return resolve(this.window.fbq('trackCustom', actionType, payload))
      } else {
        return reject(new Error('Facebook tracking event failed'))
      }
    })
  }
}

export default new FacebookPixelService(window)
